export const SET_REPORT_SETTINGS = 'SET_REPORT_SETTINGS';
export const CLEAR_REPORT_FILTERS = 'CLEAR_REPORT_FILTERS';

/**
 Function sets a subset of settings on the store. the settings options are below:
{
  isShi
  selectedCrop
  sampleFilters: {
    crop
    field
    farm
    plantedCrop
    includeNext
    startDate
    endDate
  },
  selectedIndicatorKey
  grouping
  unit
  sort
};
**/
export function setReportSettings(settings, selectedIndicator=null) {
  return {
    type: 'SET_REPORT_SETTINGS',
    settings,
    selectedIndicator
  };
}

export function clearFilters() {
  return {
    type: CLEAR_REPORT_FILTERS
  };
}

